import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import cs from "classnames";
import classes from "./MaorButton.module.scss";
import Icon, { NAMES, SIZES } from "../../../../atoms/Icon";
import { scroller } from "react-scroll";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { LOCALES, useLocale } from "../../../../../hooks/useLocale/useLocale";
import Modal from "../../../../organisms/Modal";
import BirthdayPackages from "../../../../organisms/BirthdayPackages";
import { useModal } from "../../../../../hooks";

const MaorButton = observer(() => {
  const { t } = useTranslation();

  const locale = useLocale(); // Get the locale from domain
  const isHeb = locale === LOCALES.HE; // Check if Hebrew (RTL)
  const birthdayPackagesModal = useModal();

  const onScrollToAudioSection = useCallback(() => {
    scroller.scrollTo("audio", { duration: 500, smooth: true, offset: -24 });
  }, [scroller]);

  const onScrollToVideoSection = useCallback(() => {
    scroller.scrollTo("videoList", {
      duration: 500,
      smooth: true,
      offset: -24,
    });
  }, [scroller]);

  const onScrollToColoringSection = useCallback(() => {
    scroller.scrollTo("coloring", { duration: 500, smooth: true, offset: -24 });
  }, [scroller]);

  const MyMaorButtons = [
    {
      title: t("pages.mymaor.navigation_buttons.audio"),
      color: "dark-green",
      icon: NAMES.HeadphoneIcon,
      navigator: onScrollToAudioSection,
      hidden: isHeb,
    },
    {
      title: t("pages.mymaor.navigation_buttons.coloring"),
      color: "green",
      icon: NAMES.ColoringIcon,
      navigator: onScrollToColoringSection,
      hidden: false,
    },
    {
      title: t("pages.mymaor.navigation_buttons.library"),
      color: "yellow",
      icon: NAMES.VideoLibrary,
      navigator: onScrollToVideoSection,
      hidden: false,
    },
    {
      title: t("pages.mymaor.navigation_buttons.celebration"),
      color: "pink",
      icon: NAMES.BirthdayCelebration,
      navigator: () => {
        // birthdayPackagesModal.onOpen();
        window.location.href = "https://secure.cardcom.solutions/e/xO21";
      },
      hidden: false,
    },
  ];

  return (
    <div
      className={cs(
        classes.maorButtonConatiner,
        isHeb && classes.rtlMaorButtonContainer
      )}
    >
      {MyMaorButtons.map((item, index) => {
        const isLastChild = index === MyMaorButtons.length - 1;
        return (
          <div
            key={item.title}
            className={cs(
              classes.maorButton,
              classes[item.color],
              isLastChild && classes.lastChild,
              // isHeb && classes.fullWidth,
              {
                [classes.hidden]: item.hidden,
              }
            )}
            onClick={() => {
              item.navigator();
            }}
          >
            <div className={cs(classes.buttonIcon)}>
              <Icon name={item.icon} size={isMobile ? SIZES.L : SIZES.XXL} />
            </div>
            <p>{item.title}</p>
          </div>
        );
      })}

      <Modal
        opened={birthdayPackagesModal.isOpened}
        style={birthdayPackagesModal.style}
      >
        <div
          data-name="modal-overlay1"
          className={classes.overlay}
          role="button"
          onClick={(event) => {
            if (event.target.matches(`[data-name="modal-overlay1"]`))
              birthdayPackagesModal.onClose();
          }}
        >
          <div className={cs("bgc-white p-05 br-08 pos-relative")}>
            <div className={cs(classes.closeButtonContainer)}>
              <button
                className={classes.close}
                onClick={() => {
                  birthdayPackagesModal.onClose();
                }}
              >
                <Icon name="exit" size="l" />
              </button>
            </div>
            <BirthdayPackages />
          </div>
        </div>
      </Modal>
    </div>
  );
});

export default MaorButton;
